import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-464ae525"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "app-content"
}
const _hoisted_2 = { class: "main-format-section" }
const _hoisted_3 = {
  key: 1,
  class: "app-content nohavePermission"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-a-wuquanxian1" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "页面暂无权限", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, "沪ICP备 15057767 号-9", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_global_full_screen_loading = _resolveComponent("global-full-screen-loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.collapseState ? 'app-main-area active' : 'app-main-area')
  }, [
    (_ctx.havePermission)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_view, null, {
              default: _withCtx(({ Component }) => [
                _createVNode(_Transition, {
                  name: "fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_KeepAlive, null, [
                      (_ctx.$route.meta.cache)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: 0 }))
                        : _createCommentVNode("", true)
                    ], 1024))
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_Transition, {
                  name: "fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.$route.meta.cache)
                      ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: 0 }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6)),
    _hoisted_7,
    _createVNode(_component_global_full_screen_loading)
  ], 2))
}